import { IContactModel } from '../contacts/contact.model';
import { ISlickFileModel } from 'slick-components';

export interface IWarrantyRegistrationModel {
	warrantyRegistrationId: number;
	customerId: number;
	warrantyContact: IContactModel;
	allowPromotionalPhotos: boolean;
	overallRating: number;
	installRating: number;
	installerRating: number;
	installerName: string;
	additionalComments: string;
	sendCareSuggestions: boolean;
	sendCareEmailAddress: string;

	photos: ISlickFileModel[];
}

export class WarrantyRegistrationModel implements IWarrantyRegistrationModel {
	constructor() {
		this.allowPromotionalPhotos = true;
		this.sendCareSuggestions = true;
	}

	warrantyRegistrationId: number;
	customerId: number;
	warrantyContact: IContactModel;
	allowPromotionalPhotos: boolean;
	overallRating: number;
	installRating: number;
	installerRating: number;
	installerName: string;
	additionalComments: string;
	sendCareSuggestions: boolean;
	sendCareEmailAddress: string;

	photos: ISlickFileModel[];
}